import { z } from 'zod';
export const politicianSchema = z.object({
    id: z.number(),
    source: z.string(),
    external_id: z.string(),
    name: z.string(),
    party: z.string().nullable().optional(),
    state: z.string().nullable().optional(),
    role: z.string(),
    photo: z.string().nullable().optional(),
    source_url: z.string().nullable().optional(),
    current: z.boolean().optional(),
    profile: z.record(z.string(), z.unknown()).optional(),
    expenses: z.object({
        value: z.number().nullable(), records: z.number(), complete: z.boolean(),
        updated_at: z.string().nullable().optional(), source_url: z.string().nullable().optional(),
        public_url: z.string().nullable().optional(), note: z.string().optional(),
    }).optional(),
    proposals: z.number().nullable().optional(),
    votes: z.number().nullable().optional(),
    monthly: z.number().nullable().optional(),
    performance_value: z.number().nullable().optional(),
    performance_label: z.string().nullable().optional(),
    biography: z.string().nullable().optional(),
    biography_topics: z.array(z.string()).nullable().optional(),
});
export const pageSchema = z.object({
    items: z.array(z.unknown()), total: z.number(), page: z.number(), size: z.number(),
});
export const listResponseSchema = pageSchema.extend({
    items: z.array(politicianSchema),
    performance: z.string().optional(), performance_label: z.string().nullable().optional(), note: z.string().optional(),
});
